<template>
  <div class="bottom_tabbar" v-if="!VerificationSecurityCodeWindow">
    <div></div>
    <div class="payment_amount"> {{ tools.GetLanguageValue("public.app.已点") }} {{ $store.state.Carts.PlaceCount }} </div>
    <div class="confirm_payment" @click="VerificationSecurityCode()">
      {{ tools.GetLanguageValue("public.app.下单") }} ( {{ $store.state.Carts.NotPlaceCount }})
    </div>
  </div>

  <div class="bottom_tabbar_cart" @click="Skip('storeshoppingcart')" v-if="!VerificationSecurityCodeWindow">
    <van-icon name="shopping-cart-o" color="#fff" :size="33" />
  </div>

  <!-- 确认页面 -->
  <van-action-sheet :style="{ height: clientHeight - 200 + 'px' }" style="min-height: 300px;"
    v-model:show="AffirmOrderWindow" :title="tools.GetLanguageValue('public.app.确认下单')">

    <AffirmPlaceOrder :Model="guid" :placeOrder="PlaceOrder" :update="UpdateProduct"></AffirmPlaceOrder>
    <div class="confirm_placeOrder" @click="PayOrder()">
      {{ tools.GetLanguageValue("public.app.下单") }} ({{ $store.state.Carts.NotPlaceCount }})
    </div>

  </van-action-sheet>

  <!-- 确认码 -->
  <van-action-sheet :style="{ height: clientHeight - 200 + 'px' }" style="min-height: 300px;"
    v-model:show="VerificationSecurityCodeWindow" :title="tools.GetLanguageValue('public.app.请联系服务员输入验证码')">

    <div class="input_area">

      <div style="width: 320px;margin: 0 auto;border:1px solid #e6e6e6;">
        <van-password-input :length="4" :mask="false" :value="SecurityCode" :gutter="10" />
      </div>
    </div>
    <!-- 数字键盘 -->
    <van-number-keyboard theme="custom" close-button-text="✓" @input="onInput" @close="InputSecurityCode"
      v-model="SecurityCode" :maxlength="4" :show="VerificationSecurityCodeWindow" @blur="showKeyboard = false" />

  </van-action-sheet>
</template>
<script >
import axios from "../../commons/AxiosMethod.js"
import commons from "../../commons/commons.js"
import tools from "../../commons/tools.js"
import AffirmPlaceOrder from "../AffirmPlaceOrder.vue"

import { showDialog, showConfirmDialog ,showToast } from 'vant'
import { mapState } from 'vuex'
 

// product_categorys
export default {
  data () {
    return {
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      UserIsAuthenticated: true,
      AffirmOrderWindow: false, // 确定下单页面
      tools: tools,
      IsDefault: false,
      IsProduct: false,
      IsTaoCan: false,
      IsTaoCanFixed: false,
      IsTaoCanQianTai: false,
      tableCart: false,
      TableId: '',
      Carts: {}, // 购物车信息
      UpdateProduct: () => { },
      PlaceOrder: () => { },
      IsSkipAffirmPlaceOrder: true, // 是否跳转到下单确认页面
      guid: '',
      VerificationSecurityCodeWindow: false,
      SecurityCode: '',
      IsOrderShowCost: false// 是否显示价格
    }
  },
  props: {
    active: "",
    update: null,
    placeOrder: null,
    Carts: {}
  },
  name: "App",
  mounted () {
    this.UpdateProduct = this.update;
    this.PlaceOrder = this.placeOrder;

    this.IsOrderShowCost = localStorage.getItem("IsOrderShowCost") == 'yes'
    this.TableId = localStorage.getItem("Cache-TableId")
  },
  components: {
    AffirmPlaceOrder
  },
  methods: {
    // 输入验证码
    InputSecurityCode () {
      if (this.SecurityCode == null || this.SecurityCode.length != 4) {
        return
      }

      var code = localStorage.getItem("System.ScanQrCodes.SecurityCode")

      axios.apiMethod(
        "/Store/StoreOrder/VerificationSecurityCode",
        "get",
        { code: this.SecurityCode },
        (result) => {
          if (result.Data.IsSuccess == true) {
            this.VerificationSecurityCodeWindow = false
            localStorage.setItem("System.ScanQrCodes.SecurityCode", this.SecurityCode)
            this.AffirmPayOrder()
          } else {
            showToast (tools.GetLanguageValue('public.app.验证失败'))
            this.SecurityCode = ""
            this.VerificationSecurityCodeWindow = true
          }
        })
    },
    // 验证验证码
    VerificationSecurityCode () {
      var useSecurityCode = localStorage.getItem('UseSecurityCode') == 'yes'

      if (useSecurityCode) {
        var code = localStorage.getItem("System.ScanQrCodes.SecurityCode")

        axios.apiMethod(
          "/Store/StoreOrder/VerificationSecurityCode",
          "get",
          { code: code },
          (result) => {
            if (result.Data.IsSuccess == false) {
              this.VerificationSecurityCodeWindow = true

              return
            }
            this.AffirmPayOrder()
          })
      } else {
        this.AffirmPayOrder()
      }
    },
    // 下单
    AffirmPayOrder () {
      if (this.IsSkipAffirmPlaceOrder) {
        this.AffirmOrderWindow = true
        this.guid = new Date().getTime() 
      } else {
        this.PayOrder()
      }
      return
    },
    PayOrder () {
    
      showDialog({
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: tools.GetLanguageValue("public.app.确认"),
        cancelButtonText: tools.GetLanguageValue("public.app.取消"),

        title: tools.GetLanguageValue("public.app.温馨提示"),
        message:
          tools.GetLanguageValue("public.app.您确定下单吗")
      })
        .then(() => {
          axios.apiMethod(
            "/Store/StoreOrder/PlaceOrder?TableId=" + this.TableId,
            "get",
            {},
            (result) => {
              if (result.Data.IsSuccess) {
                tools.GetShoppingCartComplete(this.TableId)
 
                this.UpdateProduct();
                this.PlaceOrder();
                this.AffirmOrderWindow = false;
                // window.location.reload()
              }
              showToast (result.Data.Msg)
            },
            (e) => { }
          )
        })
        .catch(() => {
          // on cancel
        })
    },
    Skip (item) {
      var TableId = localStorage.getItem("Cache-TableId")
      this.$router.push({
        path: item,
        query: {
          tableId: TableId
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.bottom_tabbar {
  background-color: #333;

  position: fixed;
  bottom: 0px;
  width: 100%;
  height: 50px;
  border-top: 1px solid #eee;
  opacity: 0.9;
  display: flex;
  justify-items: flex-end;
  justify-content: flex-end;
  color: aliceblue;

  .payment_amount {
    width: calc(100% - 150px - 85px);
    text-align: center;
    line-height: 50px;
    color: aliceblue;
  }

}

.bottom_tabbar_cart {
  position: fixed;

  bottom: 10px;
  left: 5px;
  height: 80px;
  width: 80px;
  background-color: rgb(0, 157, 255);
  border-radius: 40px;

  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

}

.confirm_payment {
  width: 150px;
  height: 60px;
  text-align: center;
  line-height: 50px;
  border-left: 1px solid 409eff;
  background-color: rgb(0, 157, 255);
}

//下单
.confirm_placeOrder {
  width: 100%;
  height: 60px;
  text-align: center;
  line-height: 50px;
  border-left: 1px solid 409eff;
  background-color: rgb(0, 157, 255);
  color: #eee;
  position: absolute;
  bottom: 0px;
}

.input_area {

  position: absolute;
  top: 200px;
  width: 100%;
}
</style>
